// VIP状态类型
export enum VipStatus {
  FREE = 0,
  PRO = 1,
  ACADEMIC = 2,
  PARTNER = 3,
  INTERNAL = 4,
}

// VIP状态映射
export const VIP_STATUS_LABELS: Record<VipStatus, string> = {
  [VipStatus.FREE]: 'FREE',
  [VipStatus.PRO]: 'PRO',
  [VipStatus.ACADEMIC]: 'ACADEMIC',
  [VipStatus.PARTNER]: 'PARTNER',
  [VipStatus.INTERNAL]: 'INTERNAL',
};

// VIP状态颜色映射
export const VIP_STATUS_COLORS: Record<VipStatus, string> = {
  [VipStatus.FREE]: 'default',      // 灰色 - 免费用户  
  [VipStatus.PRO]: 'orange',        // 橙色 - PRO用户（更醒目）
  [VipStatus.ACADEMIC]: 'cyan',     // 青色 - 学术用户（更清晰）
  [VipStatus.PARTNER]: 'magenta',   // 洋红色 - 合作伙伴（更鲜明）
  [VipStatus.INTERNAL]: 'lime',     // 柠檬绿 - 内部用户（更亮）
};

// 组件Props类型
export interface MetricCardProps {
  title: string;
  subtitle: string;
  value: number;
  icon: string;
  color: string;
  loading?: boolean;
}

export interface DateSelectorProps {
  availableDates: string[];
  selectedDate: string;
  onChange: (date: string) => void;
  loading?: boolean;
}

export interface UserBehaviorTableProps {
  data: any[];
  loading?: boolean;
  pagination: {
    current: number;
    pageSize: number;
    total: number;
    onChange: (page: number, pageSize: number) => void;
  };
  onUserClick?: (userId: string, userName: string) => void;
}

// 筛选器类型
export interface FilterState {
  vipStatus?: string;
  minDuration?: number;
}

// 分页状态类型
export interface PaginationState {
  current: number;
  pageSize: number;
  total: number;
}